// Ordenação das tabelas de acompanhamento pelo clique nos cabeçalhos. O primeiro clique numa
// coluna ordena em ordem crescente, o seguinte inverte. Valor nulo ou vazio fica sempre por
// último, em qualquer direção: é o que a coluna de cliente do cliente, nula na maioria dos jobs,
// exige para a ordenação fazer sentido (sc-9885).
const vazio = (v) => v === null || v === undefined || v === "";

var TableFilter = {
    data() {
        return {
            attrFilter: "",
            order: true,
            filter: [],
        };
    },
    methods: {
        changeFilter(attr, index) {
            this.order = !this.order;
            this.attrFilter = attr;
            this.filter = []
            for(let i = 0; i<5; i++ ) this.filter.push(false)
            this.filter[index] = true        
        },
        filterIcons(text, index) {
            if (!this.filter[index]) return text
            if (!this.order && this.filter[index]) return text + ` <i class="fa fa-filter"></i>`
            if (this.order) return text
        }
    },
    computed: {
        jobsFilter() {
            if (!this.attrFilter) return this.jobs;
            const attr = this.attrFilter;
            const order = this.order;
            const numerico = this.jobs.some(j => Number.isInteger(j[attr]));
            return this.jobs.slice().sort(function (a, b) {
                const va = a[attr], vb = b[attr];
                if (vazio(va) && vazio(vb)) return 0;
                if (vazio(va)) return 1;
                if (vazio(vb)) return -1;
                const r = numerico ? va - vb : String(va).localeCompare(String(vb));
                return order ? -r : r;
            });
        }
    }
}

export default TableFilter
